module.exports = __webpack_public_path__ + "static/img/clara.ce2fb2c8.png";